export function DynamicStorage(key: string) {
  return function (target: any, propertyKey: string) {
    const storageKey = `vengreso.${key || propertyKey}`;

    Object.defineProperty(target, propertyKey, {
      get() {
        // Updated to use new consistent masquerade key
        const isMasquerading = !!sessionStorage.getItem("fms-masquerade-user-id");
        const storage = isMasquerading ? sessionStorage : localStorage;
        const value = storage.getItem(storageKey);
        return value ? JSON.parse(value) : null;
      },
      set(value: any) {
        // Updated to use new consistent masquerade key
        const isMasquerading = !!sessionStorage.getItem("fms-masquerade-user-id");
        const storage = isMasquerading ? sessionStorage : localStorage;
        if (value === null || value === undefined) {
          storage.removeItem(storageKey);
        } else {
          storage.setItem(storageKey, JSON.stringify(value));
        }
      }
    });
  };
}
